
const DYNAMIC_BOOK_COLLECTION_TEMPLATE = `
    <section id="alphafilter-component">
        <div id="alphafilter"></div>
    </section>
    <section id="bookCollection" class=""></section> 
    <section id="pagination-component" style="text-align:center;"></section>
`;

const DynamicBookCollectionView = Backbone.View.extend({

    id: "dynamic-book-collection-view",

    className: "container",

    template: _.template( DYNAMIC_BOOK_COLLECTION_TEMPLATE ),

    // The subcomponents of the page
    components: {
        alphafilter: {},
        bookCollectionView: {},
        paginatedView: {},
    },

    collection: {},

    displayedCollection: {},

    animateBooks: function() {
        BookCollectionView.animate(".bookContainer");
    },

    afterRender: function() {
        this.animateBooks();
    },

    initialize: function() {
        // initialize the page's properties that will be given to the subcomponents
        this.displayedCollection = this.collection.clone().paginate(0);
        this.paginationCollection = this.collection.clone();

        // initialize the subcomponents
        this.components.alphafilter = new AlphaFilterComponent({ collection: this.collection.clone() });
        this.components.paginatedView = new PaginationComponent({ collection: this.paginationCollection });
        this.components.bookCollectionView = new BookCollectionView({ collection: this.displayedCollection });

        // listen to the events of the relevent subcomponents
        this.components.alphafilter.el.addEventListener("letter", (e) => this.updateAlpha(e.detail.collection()));
        this.components.paginatedView.el.addEventListener("page", (e) => this.update(e.detail.collection()));
    },

    render: function() {

        this.$el.html(this.template());
        this.$el.find("#alphafilter-component").html(this.components.alphafilter.render().el);
        this.$el.find("#bookCollection").html(this.components.bookCollectionView.render().el);
        this.$el.find("#pagination-component").html(this.components.paginatedView.render().el);

        this.animateBooks();

        return this;
    },

    update: function(newCollection) {
        this.displayedCollection.set(newCollection.slice(0, 12));
    },

    updateAlpha: function(newCollection) {
        this.paginationCollection.set(newCollection);
        this.update(newCollection);
    }

});